import { Tag } from "@chakra-ui/react";

type Props = {
  value: string | number;
};

function ConfidenceTag ({ value }: Props) {
  function tagColorScheme(value: number){
    if (value >= 0.8) {
      return "green";
    } else if (value >= 0.65) {
      return "teal";
    } else if (value >= 0.5) {
      return "orange";
    } else {
      return "gray";
    }
  }
  return (
    <Tag size="sm" borderRadius="full" colorScheme={tagColorScheme(Number(value))}>{value}</Tag>
  );
}

export default ConfidenceTag;
